import { ProviderType } from "#/pages/provider-finder/utils/parentIdMapping"
import { ProviderFinderParam } from "#/pages/provider-finder/utils/providerFinderSearchUrl"
import { useHistory } from "react-router"

export const PROVIDER_TYPE_SEARCHED: Record<string, ProviderType> = {
  "1": ProviderType.FertilityClinics,
  "2": ProviderType.ReproductiveUrology,
  "3": ProviderType.Adoption,
  "5": ProviderType.CryobanksStorageFacilities,
  "7": ProviderType.Menopause,
  "6": ProviderType.LowTestosterone,
  "34": ProviderType.GenderAffirmingHormoneTherapy,
  "35": ProviderType.DonorAssistance,
  "36": ProviderType.GestationalSurrogacy,
  "37": ProviderType.PelvicFloorTherapy,
  "44": ProviderType.Doulas
}

export function useProviderTypeSearched(providerType: string = null): {
  isDoulasSearched: boolean
  isFertilityClinicsSearched: boolean
  isMenopauseSearched: boolean
  isPelvicFloorTherapySearched: boolean
  providerTypeSearched: ProviderType
  providerTypeId: string
} {
  const history = useHistory()
  const params = new URLSearchParams(history.location.search)
  const providerTypeId = providerType ?? params.get(ProviderFinderParam.ProviderType)
  return {
    isDoulasSearched: providerTypeId === "44",
    isFertilityClinicsSearched: providerTypeId === "1",
    isMenopauseSearched: providerTypeId === "7",
    isPelvicFloorTherapySearched: providerTypeId === "37",
    providerTypeSearched: PROVIDER_TYPE_SEARCHED[providerTypeId],
    providerTypeId
  }
}
